module.exports = __webpack_public_path__ + "img/Strelica_svetlo_zelena_desno.0e28d56b.svg";